const AdminEventDetails = () => {
    return (
        <div>
            <h1>Event Details</h1>
        </div>
    );
}

export default AdminEventDetails;